export interface IBreadCrumb {

    Index: number;
    Title: string;
    Link: string;
    Tooltip: string;

}

export class BreadCrumb implements IBreadCrumb {

    Index: number;
    Title: string;
    Link: string;
    Tooltip: string;

}
